<div class="to-top-container">
  <button type="button" (click)="scrollToTop()" class="to-top-btn">
    <span class="material-symbols-outlined">
      keyboard_arrow_up
    </span>
  </button>
</div>